// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/used/map.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/used/homepage-line.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/used/map-0.35.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/used/homepage-line-inverted.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fs-10 {
  font-size: 10px;
}

.fs-11 {
  font-size: 11px;
}

.fs-12 {
  font-size: 12px;
}

.fs-13 {
  font-size: 13px;
}

.fs-14 {
  font-size: 14px;
}

.fs-15 {
  font-size: 15px;
}

.fs-16 {
  font-size: 16px;
}

.fs-17 {
  font-size: 17px;
}

.fs-18 {
  font-size: 18px;
}

.fs-19 {
  font-size: 19px;
}

.fs-20 {
  font-size: 20px;
}

.fs-21 {
  font-size: 21px;
}

.fs-22 {
  font-size: 22px;
}

.fs-23 {
  font-size: 23px;
}

.fs-24 {
  font-size: 24px;
}

.fs-25 {
  font-size: 25px;
}

.fs-26 {
  font-size: 26px;
}

.fs-27 {
  font-size: 27px;
}

.fs-28 {
  font-size: 28px;
}

.fs-29 {
  font-size: 29px;
}

.fs-30 {
  font-size: 30px;
}

.fs-31 {
  font-size: 31px;
}

.fs-32 {
  font-size: 32px;
}

.fs-33 {
  font-size: 33px;
}

.bold {
  font-weight: bold;
}

.light-grey {
  color: gray;
}

.clr-text {
  color: gray !important;
}

.black {
  color: #000000;
}

.bg-white {
  background-color: "white";
}

.bg-Dgray {
  background-color: #53565A !important;
}

/* Headers CSS */
.header-main {
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;
  z-index: 1000;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}

.header-left {
  font-size: 31px;
  color: gray;
  cursor: pointer;
  font-weight: bold;
  position: relative;
}

.header-right {
  font-size: 19px;
  color: #43B02A;
  cursor: pointer;
  font-weight: bold;
  position: relative;
}

.header-left-small-screens {
  font-size: 19px;
}

.header-small-screens {
  font-size: 14px;
}

.header-login {
  padding: 3px 30px 3px 30px;
  border: 1px solid #43B02A;
  color: #43B02A;
  background-color: white;
  border-radius: 15px;
  cursor: pointer;
}

.header-second {
  color: #53565A;
  font-size: 19px;
  font-weight: 500;
}

.pointer {
  cursor: pointer;
}

.highlight {
  text-decoration-line: underline;
  text-decoration-color: #43B02A;
}

/* Landing CSS */
html {
  scroll-behavior: smooth;
}

.landing-image {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: end;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
}

.landing-image-mask {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  position: absolute;
  width: 100%;
  height: 20%;
  bottom: 0;
  left: 0;
  z-index: 3;
  background-size: cover;
}

.trace-sideline {
  width: 58%;
  height: 70%;
  position: absolute;
  bottom: -50%;
  left: -47%;
  z-index: 4;
}
@media (max-width: 1400px) {
  .trace-sideline {
    width: 50em;
    height: 70%;
    bottom: -50%;
    left: -53%;
  }
}
@media (max-width: 1250px) {
  .trace-sideline {
    width: 42em;
    height: 70%;
    bottom: -50%;
    left: -58%;
  }
}
@media (max-width: 960px) {
  .trace-sideline {
    width: 70%;
    height: 103%;
    bottom: -50%;
    left: -58%;
  }
}
@media (max-width: 660px) {
  .trace-sideline {
    display: none;
  }
}

.trace-right-line {
  width: 40%;
  height: 22%;
  position: absolute;
  bottom: 64%;
  right: 0%;
  /* transform: rotateZ(120deg); */
  z-index: 1;
}
@media (max-width: 1250px) {
  .trace-right-line {
    width: 32rem;
    height: 44rem;
    bottom: 48%;
  }
}
@media (max-width: 960px) {
  .trace-right-line {
    width: 22rem;
    height: 32rem;
    bottom: 51%;
  }
}
@media (max-width: 660px) {
  .trace-right-line {
    display: none;
  }
}

.landing-bottom-circle {
  position: absolute;
  bottom: -15px;
  background-color: #E03C31;
  border-radius: 50%;
  padding: 5px;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  line-height: 0.1;
  cursor: pointer;
}

.bottom-icon {
  color: white;
  font-weight: bold;
  font-size: 20px;
  padding-top: 15px !important;
}

@keyframes arrowDown {
  0% {
    position: relative;
  }
  100% {
    padding-top: 10px;
  }
}
.arrow-icon {
  padding-right: 0.5px;
}
.arrow-icon:hover {
  animation-name: arrowDown;
  animation-duration: 1s;
}

.landing-page-container {
  height: 100vh;
}

.landing-container {
  z-index: 100;
  margin-top: 12%;
  max-width: 55%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  display: flex;
  padding: 20px 30px 30px 30px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.9);
  gap: 5px;
}

.landing-container-heading {
  font-size: 32px;
  font-weight: bold;
  padding: 0 10px;
}

.landing-font {
  font-size: 15px;
  color: #53565A;
}

.search-bar {
  height: 40px;
}

.landing-btn {
  padding: 7px 15px 7px 15px;
  height: 40px;
  border: none;
  color: white;
  background-color: #43B02A;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.landing-btn-container {
  display: flex;
  justify-content: center;
}

.landing-input {
  height: 100%;
  outline-style: none;
  box-shadow: none;
  border-color: transparent;
  border: none;
  text-indent: 10px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  border: 1px solid lightgrey;
}

.landing-input-size {
  width: 100%;
  font-size: xx-small !important;
}

@media only screen and (min-width: 800px) {
  .landing-input-size {
    width: 300px;
  }
}
.right-round {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.search-bottom {
  font-weight: bolder;
  font-size: 16px;
  text-decoration-line: underline;
  color: #702082;
}

.listbox {
  cursor: pointer;
  margin-top: 40px;
  width: 300px;
  padding: 0;
  z-index: 1;
  position: absolute;
  list-style: none;
  background-color: #f3f3f3;
  overflow: auto;
  max-height: 200px;
  border: 1px solid rgba(0, 0, 0, 0.25);
}

.text-small {
  font-size: small;
}

/* FAQ CSS */
.faq-heading {
  color: #702082;
  font-weight: bold;
  font-size: 35px;
}

/* Loader CSS */
.center-fixed {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 111;
  background: rgba(0, 0, 0, 0.3);
}

.start-button {
  border-radius: 20px;
  border: 0;
  color: white;
  font-weight: bold;
  padding: 5px 20px 5px 20px;
}

.video-button {
  z-index: 3;
  position: absolute;
  bottom: 10%;
  left: 45%;
  border-radius: 40px;
  border: 0;
  color: white;
  background-color: #e10001;
  font-size: 30px;
  font-weight: bold;
  padding: 5px 20px 5px 20px;
}

.video-icon {
  padding-bottom: 2px;
  margin-left: 8px;
}

.section2-lp {
  margin-left: 12%;
  margin-right: 12%;
}
@media (max-width: 768px) {
  .section2-lp {
    margin-left: 9%;
    margin-right: 9%;
  }
}
@media (max-width: 600px) {
  .section2-lp {
    margin-left: 8%;
    margin-right: 8%;
  }
}

.house-img {
  width: 90%;
  height: 90%;
}

.house-img-last-section-1 {
  width: 20%;
  height: 100%;
}

.house-img-last-section-2 {
  width: 30%;
  height: 100%;
}

.house-img-last-section-3 {
  width: 40%;
  height: 100%;
}

.en-center {
  display: flex;
  justify-content: center;
}

.w-80p {
  width: 80% !important;
}

/* Color Classes */
.primary-clr {
  color: #43B02A;
}

.secondary-clr {
  color: #702082;
}

@media screen and (max-width: 1400px) {
  .landing-container {
    max-width: 400px;
    padding: 10px 15px 15px 15px;
  }
  .landing-container-heading {
    font-size: 20px;
  }
  .landing-font {
    font-size: 12px;
  }
  .video-button {
    font-size: 20px;
  }
  .video-icon {
    width: 30px;
    height: 40px;
  }
}
/* Containers CSS*/
.container-image {
  width: 100%;
  height: 100%;
}

.container-line-img {
  position: relative;
  bottom: 5.5%;
  left: 0px;
}

.container-heading {
  color: #702082;
  font-weight: bold;
  font-size: 35px;
}

.container-heading-2 {
  font-size: 28px;
  color: #702082;
  font-weight: bold;
}

.side-margin {
  margin-left: 150px;
  margin-right: 150px;
}

.container-content {
  display: flex;
  justify-content: center;
  font-size: 17px;
  color: #53565A;
  text-align: left !important;
}

.center-text {
  text-align: center !important;
}

.container-content-btn {
  padding: 7px 20px 7px 20px !important;
  border: 1px solid #E03C31 !important;
  color: white;
  background-color: #E03C31;
  border-radius: 30px !important;
  cursor: pointer;
}

.container-vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.container-grid-img {
  width: 127px !important;
  height: 127px !important;
}

.container-grid-head {
  color: #525252;
}

.container-grid-para {
  font-size: 14px;
  color: #525252;
}

.container-grid-btn {
  font-size: 15px;
  color: #E03C31 !important;
  font-weight: bold;
  text-decoration-line: underline;
  cursor: pointer;
}

.circled-border {
  border: 1px solid transparent;
  display: block;
}

.circled-border:hover {
  border: 1px solid rgba(83, 86, 90, 0.062745098);
  border-radius: 50%;
  cursor: pointer;
  width: 100%;
}

.example-top-image-right {
  position: relative;
  margin-left: 29%;
  margin-top: -148%;
}

.example-top-image-left {
  position: relative;
  margin-top: -148%;
  margin-left: -28%;
}

ul.green-list {
  list-style-type: disc;
  color: #66B654;
}

.conatiner-bg-grey {
  background-color: #F5F5F5;
}

@media only screen and (max-width: 1150px) {
  .container-line-img {
    position: relative;
    bottom: 5.3%;
    left: 0px;
  }
}
@media only screen and (max-width: 960px) {
  .container-line-img {
    position: relative;
    bottom: 3%;
    left: 0px;
  }
}
@media only screen and (max-width: 850px) {
  .container-line-img {
    position: relative;
    bottom: 5px;
    left: 0px;
  }
}
@media only screen and (max-width: 600px) {
  .container-line-img {
    position: relative;
    bottom: 2px;
    left: 0px;
  }
}
.login-height {
  min-height: calc(100vh - 125px);
}

.login-btn {
  background-color: #43B02A !important;
  border-color: #43B02A;
  color: white !important;
}

.login-text {
  color: white;
  white-space: nowrap;
}

.login-bg {
  background-color: #43B02A !important;
}

.icon-auth {
  position: absolute;
  right: 10px;
  color: #43B02A;
}

.password-icon-register {
  top: 45px;
}

.password-icon-login {
  top: 12px;
}

.invalid-field-label {
  font-size: 80%;
  margin-top: 5px;
  color: #dc3545;
}

.sidepanel-container {
  position: relative;
  display: block;
  float: right;
  right: 45px;
  top: 20px;
  width: 100% !important;
  padding-bottom: 10px;
}
@media screen and (max-width: 600px) {
  .sidepanel-container {
    right: 0px;
  }
}
.sidepanel-panel {
  width: 100%;
  border-top: 4px solid #43B02A;
  background-color: white;
}
.sidepanel-button {
  border: 1px solid #E03C31;
  padding: 5px 15px 5px 15px;
  text-align: center;
  color: #E03C31;
  font-size: 11px;
  border-radius: 25px;
  background-color: white;
}
.sidepanel-ful-btn {
  border: 1px solid #E03C31;
  text-align: center;
  font-size: 16px;
  font-weight: normal;
  font-family: Barlow;
  color: rgb(0, 0, 0);
  border-radius: 5px;
  border-color: green;
  background-color: white !important;
}
.sidepanel-input {
  min-width: 100%;
  padding: 7px;
  outline-style: none;
  box-shadow: none;
  border-radius: 20px;
  border-color: transparent;
  border: none;
  text-indent: 10px;
  border: 1px solid lightgrey;
}
.sidepanel-search {
  top: 8px;
  right: 15px;
  position: absolute;
  cursor: pointer;
  bottom: 100px;
}
.sidepanel-close-icon {
  position: absolute;
  top: 32px;
  left: -55px !important;
}
.sidepanel-with-down {
  position: absolute;
  top: 93px !important;
}
.sidepanel-hide-panel {
  position: absolute;
  right: -66px;
  top: 40px;
  transform: rotate(180deg);
}
.sidepanel-future {
  color: white !important;
  font-size: 11px;
  background-color: #53565A !important;
}
.sidepanel-current {
  color: gray !important;
  font-size: 11px;
  background-color: white !important;
}
.sidepanel-chevron {
  font-size: 15px;
  color: gray;
  transform: translateY(-3px);
}
.sidepanel-chevron-rotate {
  font-size: 15px;
  color: gray;
  transform: translateY(-3px) rotate(180deg);
}
.sidepanel-inside {
  position: relative;
  background-color: rgba(83, 86, 90, 0.062745098);
  height: 100%;
  width: 100%;
}
.sidepanel-sm-input {
  width: 100%;
  border-radius: 5px;
  border: 1px solid grey;
}
.sidepanel-input-error {
  width: 100%;
  border-radius: 5px;
  border: 1px solid red;
}
.sidepanel-section:hover {
  background-color: rgba(83, 86, 90, 0.062745098) !important;
}
.sidepanel-radioList {
  display: flex;
  flex-direction: column;
}
.sidepanel-vertical {
  display: flex !important;
  justify-content: center !important;
  flex-direction: column !important;
}
.sidepanel-multi-label {
  padding-left: 35%;
  transform: translateY(-2px);
}
.sidepanel-multi-label-span {
  border-radius: 50%;
  font-size: 14px;
  background: white;
  padding: 1px 9px;
}
.sidepanel-H-center {
  display: flex !important;
  justify-content: center !important;
}
.sidepanel-mandatory {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  font-size: 13px;
  color: gray;
}
.sidepanel-add {
  position: absolute;
  top: -13px;
}
.sidepanel-add-icon {
  padding: 0px 5px 1.5px 5px;
  color: white;
  background: #53565a;
  border-radius: 50%;
}
.sidepanel-slider {
  display: flex;
  margin: 0 auto;
  justify-content: center;
}
.sidepanel-label {
  width: 50px;
  display: block;
}
.sidepanel-input[type=checkbox] {
  margin-left: 0px;
  margin-right: 0px;
}
.sidepanel-li {
  flex: 0 1 33%;
  list-style: none;
  position: relative;
}
.sidepanel-li:first-child:before {
  content: "";
  position: absolute;
  height: 1px;
  width: 20%;
  background: black;
  top: 12px;
  right: 100%;
}
.sidepanel-li:after {
  content: "";
  position: absolute;
  height: 1px;
  width: 100%;
  background: black;
  top: 12px;
  left: 25% !important;
}
.sidepanel-li:last-child:after {
  content: "";
  position: absolute;
  height: 1px;
  width: 20%;
  background: black;
  top: 12px;
  left: 100%;
}
.sidepanel-btn-center, .sidepanel-btn-right, .sidepanel-btn-left {
  background-color: #9ca5b1;
  padding: 3px 20px;
  color: white;
  font-size: 15px;
  border: 1px solid white;
}
.sidepanel-btn-left {
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}
.sidepanel-btn-right {
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.sidepanel-active-border {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.sidepanel-download-button {
  background-color: #DC3B30;
  border-radius: 30px;
  float: right;
  color: #fff;
  border: none;
  font-size: 15px;
  padding: 6px 15px;
  margin-top: -14px;
}

.sidepanel-download-button:hover {
  background-color: #b13128;
}

h4, .h4 {
  /* font-size: 1.5rem; */
  font-size: 15px;
  font-weight: bold;
}

/* Multicolor Labels */
small, .small {
  font-size: 11px;
  font-weight: 400;
}

textarea:focus, input:focus {
  outline: none;
}

/* Material UI Text-Field*/
.MuiInputBase-input {
  font: inherit;
  color: currentColor;
  width: 250px !important;
  border: 0;
  height: 2em;
  margin: 0;
  display: block;
  padding: 20px !important;
  min-width: 0;
  background: white !important;
  box-sizing: content-box;
  animation-name: mui-auto-fill-cancel;
  letter-spacing: inherit;
  animation-duration: 10ms;
  -webkit-tap-highlight-color: transparent;
}

.MuiInputBase-root {
  color: rgba(0, 0, 0, 0.87);
  background-color: white !important;
  cursor: text;
  width: 285px;
  height: 59px !important;
  padding-top: 4px !important;
  display: inline-flex;
  position: relative;
  font-size: 1rem;
  box-sizing: border-box;
  align-items: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  line-height: 1.1876em;
  letter-spacing: 0.00938em;
}

/* Material UI DatePickers */
.MuiPickersDay-daySelected {
  color: #fff;
  font-weight: 500;
  background-color: #43B02A !important;
}

.MuiPickersToolbar-toolbar {
  height: 100px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  background-color: #43B02A !important;
}

.MuiButton-textPrimary {
  color: #43B02A !important;
}

.MuiTypography-colorPrimary {
  color: #43B02A !important;
}

.MuiFilledInput-inputAdornedEnd {
  margin-top: 12px !important;
}

.MuiInputLabel-shrink {
  z-index: 999 !important;
  transform: translate(0, 18px) scale(0.75) !important;
  transform-origin: top left;
}

.MuiFormHelperText-root {
  display: none !important;
}

.MuiTableCell-root {
  border-bottom: none !important;
  font-family: "Barlow" !important;
}

.MuiTypography-body1 {
  font-family: "Barlow" !important;
}

.MuiFormLabel-root {
  font-family: "Barlow" !important;
}

.MuiButton-root {
  font-family: "Barlow" !important;
}

/* SELECT DROPDOWN */
.MuiMenu-paper {
  max-height: 400px !important;
  -webkit-overflow-scrolling: touch;
}

/* MENU DROPDOWN */
.MuiList-padding {
  padding-top: 8px !important;
  padding-bottom: 0px !important;
}

/* AUTOCOMPLETE */
.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot {
  padding-right: 56px !important;
  width: 285px !important;
}

/* MODAL INFO PAGE */
.react-responsive-modal-modal {
  min-width: 90%;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
  background: #ffffff;
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);
  margin: 1.2rem;
  padding: 1.2rem;
  position: relative;
  overflow-y: auto;
}

.form-select {
  width: auto !important;
  box-shadow: none !important;
  border: 1px solid #ced4da !important;
}

.rounded-span {
  text-align: center;
  color: white;
  padding: 3px 20px 3px 20px;
  background-color: #53565A;
  border: 1px solid #53565A;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  font-size: 11px;
  cursor: pointer;
}

.rounded-span2 {
  text-align: center;
  color: gray;
  padding: 3px 15px 3px 15px;
  background-color: white;
  font-size: 11px;
  border-left: 1px solid #53565A !important;
  border: 1px solid gray;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  cursor: pointer;
}

/* Footer CSS*/
.footer-container {
  width: 100%;
  background-color: #53565A;
  color: white;
  position: relative !important;
  bottom: 0 !important;
  display: block;
}
.footer-fixed {
  position: fixed;
}
.footer ul {
  padding: 0;
  list-style: none;
  text-align: right;
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 0;
}
@media (max-width: 500px) {
  .footer ul {
    text-align: center;
    width: 100%;
  }
}
.footer li {
  padding: 0 10px;
  color: white !important;
  opacity: 1;
  margin-top: 5px;
}
.footer ul a {
  color: inherit;
  text-decoration: none;
  color: white;
  font-size: 14px;
}
.footer-copyright {
  margin-left: 20px;
  text-align: right;
  align-self: center;
  font-size: 13px;
  color: lightgray;
  margin-bottom: 0;
  margin-top: 3px;
}
@media (max-width: 500px) {
  .footer-copyright {
    display: none;
  }
}
.footer-copyright-responsive {
  display: none !important;
}
@media (max-width: 500px) {
  .footer-copyright-responsive {
    text-align: center;
    display: block !important;
    padding-bottom: 10px;
  }
}
.footer-company-div {
  position: relative;
  top: 50%;
  transform: translateY(0%);
}
@media (max-width: 500px) {
  .footer-company-div {
    text-align: center;
    padding-top: 10px;
  }
}
.footer-company {
  cursor: pointer;
  color: #43B02A;
}
.footer-company:hover {
  color: #43B02A;
  text-decoration: none;
}
.footer-vl {
  border-left: 2px solid #43B02A;
  height: 14px;
  display: inline-block;
}

.app-content-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

.simulation-card {
  border-top: 4px solid #43B02A;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-top: 100px;
}

.zoning-card {
  width: 100%;
  height: 50%;
}

.simulation-card-header {
  background-color: rgba(83, 86, 90, 0.062745098);
  height: 60px;
}

.info-card {
  background-color: rgba(83, 86, 90, 0.062745098);
  height: 100%;
  padding-left: 10px !important;
}

.small-card {
  width: 150px;
}

.medium-card {
  width: 200px;
}

.large-card {
  width: 250px;
}

.x-large-card {
  width: 375px;
}

.half-card {
  width: 312px;
}

.full-card {
  width: 648px;
}

.inner-card-text {
  font-size: x-large;
  color: #53565A;
  font-weight: bolder;
}

.card-title {
  color: #53565A;
  font-weight: bold !important;
}

.two-unit-right {
  position: relative;
  bottom: 22px;
}

.two-unit-left {
  position: relative;
  bottom: 22px;
}

.units-text {
  font-size: small;
}

.bg-green {
  background-color: rgba(67, 176, 42, 0.231372549);
}

.bg-dark-green {
  background-color: #66b554;
}

.text-green {
  color: #43B02A !important;
}

.bg-grey {
  background-color: gray;
}

.bg-orange {
  background-color: orange;
}

.text-red {
  color: red !important;
}

.ellipses {
  width: 12em;
  overflow: hidden;
  text-overflow: ellipsis;
}

.w-90percent {
  width: 90%;
}

.cyan-bg {
  background-color: #e8e8e8;
}

.w-55percent {
  width: 55%;
}

.h-150 {
  height: 150px;
}

.text-small {
  font-size: small !important;
}

.text-x-small {
  font-size: x-small !important;
}

.overflow-y {
  overflow-y: scroll;
}

.width-90pc {
  width: 90%;
}

.width-10pc {
  width: 10%;
}

#close {
  overflow: hidden;
  position: relative;
  border: none;
  padding: 0;
  width: 2em;
  border-radius: 20%;
  background: transparent;
  color: #555555;
  font: inherit;
  text-indent: 100%;
  cursor: pointer;
}
#close:focus {
  outline: solid 0 transparent;
  box-shadow: 0 0 0 2px #a9aaaa;
}
#close:hover {
  background: rgba(145, 151, 150, 0.1);
}
#close:before, #close:after {
  position: absolute;
  top: 15%;
  left: calc(50% - 0.0625em);
  width: 0.125em;
  height: 70%;
  border-radius: 0.125em;
  transform: rotate(45deg);
  background: currentcolor;
  content: "";
}
#close:after {
  transform: rotate(-45deg);
}

.bg-images {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-blend-mode: color;
  background-size: cover;
}

.simulation-page {
  min-height: calc(100vh - 80px);
  margin-top: 80px;
  margin-left: 15%;
  margin-right: 15%;
}
@media (max-width: 576px) {
  .simulation-page {
    margin-left: 2%;
    margin-right: 2%;
  }
}
@media (max-width: 768px) {
  .simulation-page {
    margin-left: 4%;
    margin-right: 4%;
  }
}
@media (max-width: 992px) {
  .simulation-page {
    margin-left: 7%;
    margin-right: 7%;
  }
}

.simulation-page h2 {
  text-align: center !important;
  font-weight: bold;
  font-size: 28px;
  color: #53565A;
  margin-bottom: 20px;
  text-shadow: #53565A;
}

th {
  background-color: #43B02A;
  color: white;
  border-color: rgba(83, 86, 90, 0.062745098);
  text-align: center !important;
  font-weight: bold;
  font-size: 20px;
}

td, th {
  border: 1px solid none;
  padding: 8px;
  text-align: center;
}

tr:nth-child(even) {
  background-color: rgba(83, 86, 90, 0.062745098);
}

.MuiTableCell-head {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
  line-height: 1.5rem;
  font-weight: bold !important;
  font-size: 17px !important;
  color: white !important;
}

.new-sim-button {
  background-color: #702082 !important;
  border: none;
  padding: 12px 22px;
  border-radius: 28px;
  color: #fff;
  font-size: 14px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  margin-bottom: 20px;
}

.new-sim-button:hover {
  background-color: #912aa8 !important;
}

.simulationpanel-hide-panel {
  position: absolute;
  left: -10px;
  top: 140px;
}
.simulationpanel-small-screens {
  height: 40vh;
  overflow-y: scroll;
}

.resultpanel-small-screens {
  width: 80%;
  height: 30vh;
  overflow-y: auto;
  overflow-x: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  height: 9px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.zoning-fields {
  display: flex;
  align-items: center !important;
  justify-content: center;
  flex-direction: row;
  min-height: calc(100vh - 29px);
  margin-top: 50px;
}
.zoning-upload-div, .zoning-upload-msg {
  display: flex;
  align-items: center;
  justify-content: center;
}
.zoning-msg-text {
  color: gray;
  font-size: 16px;
}
.zoning-msg-text2 {
  color: #000000 !important;
  font-weight: bold !important;
  font-size: 14px !important;
}
.zoning-upload-btns, .zoning-submit {
  padding: 10px 25px;
  border: none;
  color: white;
  background-color: #43B02A;
  border-radius: 10px;
}
.zoning-remove-btn {
  padding: 8px 20px;
  border: none;
  background-color: gray !important;
  color: white !important;
  border-radius: none !important;
}
.zoning-submit {
  background-color: gray !important;
}
.zoning-select {
  position: relative;
  top: 4px;
}
.zoning-dGap {
  position: relative;
  bottom: 7px;
}

/* Containers CSS*/
.info-page-image {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.info-page-modal-image {
  width: 100%;
  height: 85vh;
}

.info-page-heading {
  color: #702082;
  font-weight: bold;
  font-size: 23px;
}

.info-page-content {
  font-size: 15px !important;
  color: black;
}

.info-page-vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.info-page-grid-img {
  width: 70px !important;
  height: 70px !important;
}

.info-page-grid-head {
  color: #525252;
}

.info-page-grid-para {
  font-size: 14px;
  color: #525252;
}

.info-page-bg-grey {
  background-color: #F3F3F3;
}

.errors-container {
  min-height: calc(100vh - 129px);
  margin-top: 100px;
}

.economic-circle, .economic-circle2, .economic-circle3 {
  height: 45px;
  width: 50px;
  border-radius: 50%;
  border: 7px solid #43B02A;
  background-color: #FFFFFF;
  position: relative;
  left: 7px;
  top: -4px;
  z-index: 9;
}
.economic-circle2, .economic-circle3 {
  border: 1px solid #43B02A;
}

.economic-circle3 {
  border: 1px solid #43B02A;
  z-index: 999 !important;
}

.economic-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #43B02A;
  font-size: 20px;
  margin-right: 2px;
}
.economic-icon .small {
  font-size: 14px;
}

.economic-text, .economic-text2, .economic-text3, .economic-light-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 13px;
  font-weight: bold;
  color: #FFFFFF;
}

.economic-text2, .economic-text3, .economic-light-text {
  color: #43B02A;
}

.economic-text3, .economic-light-text {
  color: #43B02A;
  padding-top: 5px;
}

.economic-light-text {
  font-size: 11px !important;
  font-weight: normal;
  padding-top: 0px;
}

.economic-step1, .economic-step2, .economic-step3 {
  height: 35px;
  width: 100%;
  margin-top: 6px;
  background-color: #43B02A;
  position: absolute;
  right: 0px;
  width: 91%;
}
@media screen and (max-width: 600px) {
  .economic-step1, .economic-step2, .economic-step3 {
    width: 93%;
  }
}
@media screen and (max-width: 1120px) {
  .economic-step1, .economic-step2, .economic-step3 {
    width: 94%;
  }
}

.economic-step2, .economic-step3 {
  background-color: #FFFFFF;
  border: 1px solid #43B02A;
  border-left: none;
  z-index: 99;
  width: 91%;
}
@media screen and (max-width: 1150px) {
  .economic-step2, .economic-step3 {
    width: 93%;
  }
}
@media screen and (max-width: 800px) {
  .economic-step2, .economic-step3 {
    width: 91%;
  }
}
@media screen and (max-width: 600px) {
  .economic-step2, .economic-step3 {
    width: 93%;
  }
}

.economic-step3 {
  height: 130px;
  border: 1px solid #43B02A;
  width: 94.5%;
}
@media screen and (max-width: 1150px) {
  .economic-step3 {
    width: 96%;
  }
}

/* Main Card */
/* Card-1 */
.card-container, .bottom-card-container {
  z-index: 1001;
  padding-top: 10px;
  position: relative;
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
  border: none;
}
.adjusted-height-ev-card {
  height: 600px;
}

.card-text-height {
  min-height: 59px !important;
  display: block;
}

.bar-container {
  width: 100%;
  height: 100%;
  display: inline-block;
}

.inside-container, .card-bar, .card-section-text-colored, .card2-section-text-colored, .card2-section-text-colored-2, .card-section-text-colored-2 {
  position: relative;
  width: 100%;
}

.section-heading {
  font-size: 14px;
  color: #525252;
  font-weight: bold;
}
@media screen and (max-width: 1000px) {
  .section-heading {
    font-size: x-small;
  }
}

.section-text, .card2-section-bar-bottom-text, .card2-section-bar-bottom-text-2, .section2-text, .card2-setting-text, .bar-label {
  font-size: 10px !important;
  color: #9AA1A9;
}

.section-text-2, .euro-yearly {
  font-size: 12px;
  color: #9AA1A9 !important;
  position: relative;
  bottom: 10px;
}

.section-text-3 {
  font-size: 8px;
  color: #9CA3AB;
  font-weight: normal !important;
}

.section-text-4 {
  font-size: 10px;
  font-weight: bold;
  color: #525252;
}

.section-text-5 {
  font-weight: bold;
  color: #525252;
}

.card-section-text-colored, .card2-section-text-colored, .card2-section-text-colored-2, .card-section-text-colored-2 {
  color: #702082;
  font-size: 20px;
  font-weight: bold;
  white-space: pre;
  display: block;
}
@media screen and (max-width: 1000px) {
  .card-section-text-colored, .card2-section-text-colored, .card2-section-text-colored-2, .card-section-text-colored-2 {
    font-size: small;
  }
}

.card-section-text-colored-2 {
  font-size: 12px;
  color: #9AA1A9 !important;
  top: 10px;
}

.card-bar {
  align-self: center;
}

.bar-label {
  position: relative;
  width: 20% !important;
  text-align: right;
  padding-right: 10px;
}

.section2-text, .card2-setting-text {
  padding: 0% 10%;
  font-weight: bold;
  color: #525252;
  text-align: center;
}

.section1-label {
  font-size: 12px;
  color: #B3B4B6;
}

.card-section {
  padding: 0px 20px;
}

/* Card-2 */
.card2-section1-container {
  position: relative;
  padding-top: 14.2px;
}

.card2-section2-container {
  position: relative;
  padding-bottom: 1px;
}

.card2-section3-container {
  position: relative;
  padding-bottom: 0px;
}

.card2-section-bar-bottom-text, .card2-section-bar-bottom-text-2 {
  padding-top: 2px;
  float: left;
}

.card2-section-bar-bottom-text-2 {
  float: right !important;
}

.card2-setting-container {
  text-align: left;
  margin-top: 35%;
}

.card2-section-text-colored, .card2-section-text-colored-2 {
  color: #43B02A !important;
}

.card2-section-text-colored-2 {
  font-size: 12px;
}

.card2-setting-text {
  padding: 0px;
}

.bottom-card-container {
  padding: 20px 10px;
  width: 101%;
}

/* Slider Material UI Class */
.MuiSlider-markLabel {
  color: rgba(83, 86, 90, 0.4941176471) !important;
  font-size: 10px !important;
}

.PrivateValueLabel-circle-17, .PrivateValueLabel-circle-65 {
  color: #FFFFFF !important;
  background-color: #702082 !important;
}

.MuiSlider-markLabel {
  top: 9px !important;
  transform: translateX(5px) !important;
}

.MuiSlider-markLabelActive {
  left: -20px !important;
  transform: translateX(0) !important;
}

.MuiSlider-marked {
  margin-bottom: 0px !important;
}

/* Slider Material UI Class  END */
.custom-track-label {
  position: absolute;
  left: 0px;
  top: -5px;
  font-size: 10px;
  font-weight: bold;
  color: #525252;
}

.container-exit {
  position: absolute;
  z-index: 10002;
  right: 5px;
  cursor: pointer;
}

.container-top {
  margin-top: 20px;
}

.container-hide {
  display: none !important;
}

.euro-yearly {
  position: relative;
  bottom: 3px;
}

.bottom-card-inputs {
  width: 100%;
  overflow: visible;
  border: 1px solid #702082;
  text-indent: 10px;
}

.energie-header-btn {
  font-size: 13px;
  font-weight: 600;
  background-color: #790081;
  padding: 8px;
  color: white;
  border-radius: 6px;
  border: 1px;
}

.title {
  font-weight: bold;
  color: #702081;
}

.description-text {
  font-size: smaller;
  color: #929292;
}

body, html {
  font-family: Barlow !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/ikrb/fonts.scss","webpack://./src/scss/ikrb/index.scss","webpack://./src/scss/ikrb/colors.scss","webpack://./src/scss/ikrb/_variables.scss","webpack://./src/scss/ikrb/header.scss","webpack://./src/scss/ikrb/homepage/landing.scss","webpack://./src/scss/ikrb/homepage/container.scss","webpack://./src/scss/ikrb/login.scss","webpack://./src/scss/ikrb/sidePanel.scss","webpack://./src/scss/ikrb/modificationBuiltin.scss","webpack://./src/scss/ikrb/shared.scss","webpack://./src/scss/ikrb/footer.scss","webpack://./src/scss/ikrb/app.scss","webpack://./src/scss/ikrb/simulation.scss","webpack://./src/scss/ikrb/zoning.scss","webpack://./src/scss/ikrb/infoPage.scss","webpack://./src/scss/ikrb/errors.scss","webpack://./src/scss/ikrb/economicViability.scss","webpack://./src/scss/ikrb/chart.scss"],"names":[],"mappings":"AAAA;EAAS,eAAA;ACET;;ADDA;EAAS,eAAA;ACKT;;ADJA;EAAS,eAAA;ACQT;;ADPA;EAAS,eAAA;ACWT;;ADVA;EAAS,eAAA;ACcT;;ADbA;EAAS,eAAA;ACiBT;;ADhBA;EAAS,eAAA;ACoBT;;ADnBA;EAAS,eAAA;ACuBT;;ADtBA;EAAS,eAAA;AC0BT;;ADzBA;EAAS,eAAA;AC6BT;;AD5BA;EAAS,eAAA;ACgCT;;AD/BA;EAAS,eAAA;ACmCT;;ADlCA;EAAS,eAAA;ACsCT;;ADrCA;EAAS,eAAA;ACyCT;;ADxCA;EAAS,eAAA;AC4CT;;AD3CA;EAAS,eAAA;AC+CT;;AD9CA;EAAS,eAAA;ACkDT;;ADjDA;EAAS,eAAA;ACqDT;;ADpDA;EAAS,eAAA;ACwDT;;ADvDA;EAAS,eAAA;AC2DT;;AD1DA;EAAS,eAAA;AC8DT;;AD7DA;EAAS,eAAA;ACiET;;ADhEA;EAAS,eAAA;ACoET;;ADnEA;EAAS,eAAA;ACuET;;ADpEA;EAAO,iBAAA;ACwEP;;ACjGA;EAAc,WCIJ;AFiGV;;ACpGA;EAAW,sBAAA;ADwGX;;ACvGA;EAAQ,cCKD;AFsGP;;ACzGA;EAAW,yBAAA;AD6GX;;AC5GA;EAAW,oCAAA;ADgHX;;AGtHA,gBAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,uBAAA;EACA,aAAA;EACA,mDAAA;AHyHJ;;AGrHA;EACI,eAAA;EACA,WDRM;ECSN,eAAA;EACA,iBAAA;EACA,kBAAA;AHwHJ;;AGtHA;EACI,eAAA;EACA,cDnBO;ECoBP,eAAA;EACA,iBAAA;EACA,kBAAA;AHyHJ;;AGvHA;EACI,eAAA;AH0HJ;;AGvHA;EACI,eAAA;AH0HJ;;AGvHA;EACI,0BAAA;EACA,yBAAA;EACA,cDnCO;ECoCP,uBAAA;EACA,mBAAA;EACA,eAAA;AH0HJ;;AGxHA;EACI,cDpCO;ECqCP,eAAA;EACA,gBAAA;AH2HJ;;AGxHA;EAAW,eAAA;AH4HX;;AG1HA;EACI,+BAAA;EACA,8BDlDO;AF+KX;;AI5KA,gBAAA;AAEA;EACI,uBAAA;AJ8KJ;;AI3KA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,yDAAA;EACA,sBAAA;AJ8KJ;;AI3KA;EACI,yDAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,sBAAA;AJ8KJ;;AI3KA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AJ8KJ;AI5KI;EARJ;IASQ,WAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EJ+KN;AACF;AI9KI;EAdJ;IAeQ,WAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EJiLN;AACF;AIhLI;EApBJ;IAqBQ,UAAA;IACA,YAAA;IACA,YAAA;IACA,UAAA;EJmLN;AACF;AIlLI;EA1BJ;IA2BQ,aAAA;EJqLN;AACF;;AIlLA;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;AJqLJ;AInLI;EATJ;IAUQ,YAAA;IACA,aAAA;IACA,WAAA;EJsLN;AACF;AIrLI;EAdJ;IAeQ,YAAA;IACA,aAAA;IACA,WAAA;EJwLN;AACF;AIvLI;EAnBJ;IAoBQ,aAAA;EJ0LN;AACF;;AIpLA;EACI,kBAAA;EACA,aAAA;EACA,yBFtFC;EEuFD,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AJuLJ;;AIpLA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,4BAAA;AJuLJ;;AIpLA;EACI;IAAM,kBAAA;EJwLR;EIvLE;IAAM,iBAAA;EJ0LR;AACF;AIxLA;EACE,oBAAA;AJ0LF;AIzLE;EACE,yBAAA;EACA,sBAAA;AJ2LJ;;AIvLA;EACI,aAAA;AJ0LJ;;AIvLA;EACI,YAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,QAAA;AJyLJ;;AItLA;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AJyLJ;;AItLA;EACI,eAAA;EACA,cFnJO;AF4UX;;AItLA;EACI,YAAA;AJyLJ;;AItLA;EACI,0BAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,yBFpKO;EEqKP,6BAAA;EACA,gCAAA;AJyLJ;;AItLA;EAEI,aAAA;EACA,uBAAA;AJwLJ;;AIrLA;EACI,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;EACA,+BAAA;EACA,2BAAA;AJwLJ;;AIrLA;EACI,WAAA;EACA,8BAAA;AJwLJ;;AIrLA;EACI;IACI,YAAA;EJwLN;AACF;AIrLA;EACI,6BAAA;EACA,gCAAA;AJuLJ;;AIpLA;EACI,mBAAA;EACA,eAAA;EACA,+BAAA;EACA,cF9MO;AFqYX;;AIpLA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,qCAAA;AJuLJ;;AIpLA;EACI,gBAAA;AJuLJ;;AIpLA,YAAA;AAEA;EACI,cFtOO;EEuOP,iBAAA;EACA,eAAA;AJsLJ;;AInLA,eAAA;AAEA;EACI,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;AJqLJ;;AIlLA;EACI,mBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,0BAAA;AJqLJ;;AIlLA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EAGA,iBAAA;EACA,0BAAA;AJmLJ;;AIhLA;EACI,mBAAA;EACA,gBAAA;AJmLJ;;AIhLA;EACI,gBAAA;EACA,iBAAA;AJmLJ;AIjLI;EAJJ;IAKQ,eAAA;IACA,gBAAA;EJoLN;AACF;AInLI;EARJ;IASQ,eAAA;IACA,gBAAA;EJsLN;AACF;;AInLA;EACI,UAAA;EACA,WAAA;AJsLJ;;AInLA;EACI,UAAA;EACA,YAAA;AJsLJ;;AInLA;EACI,UAAA;EACA,YAAA;AJsLJ;;AInLA;EACI,UAAA;EACA,YAAA;AJsLJ;;AInLA;EACI,aAAA;EACA,uBAAA;AJsLJ;;AInLA;EACI,qBAAA;AJsLJ;;AIpLA,kBAAA;AAEA;EAAe,cFpUJ;AF2fX;;AItLA;EAAiB,cFpUN;AF8fX;;AIvLA;EACI;IACI,gBAAA;IACA,4BAAA;EJ0LN;EIxLE;IACI,eAAA;EJ0LN;EIxLE;IACI,eAAA;EJ0LN;EIxLE;IACI,eAAA;EJ0LN;EIxLE;IACI,WAAA;IACA,YAAA;EJ0LN;AACF;AKphBA,kBAAA;AAEA;EACI,WAAA;EACA,YAAA;ALqhBJ;;AKlhBA;EACI,kBAAA;EACA,YAAA;EACA,SAAA;ALqhBJ;;AKlhBA;EACI,cHZO;EGaP,iBAAA;EACA,eAAA;ALqhBJ;;AKlhBA;EACI,eAAA;EACA,cHnBO;EGoBP,iBAAA;ALqhBJ;;AKlhBA;EACI,kBAAA;EACA,mBAAA;ALqhBJ;;AKnhBA;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,cH3BO;EG4BP,2BAAA;ALshBJ;;AKnhBA;EACI,6BAAA;ALshBJ;;AKnhBA;EACI,qCAAA;EACA,oCAAA;EACA,YAAA;EACA,yBHtCC;EGuCD,8BAAA;EACA,eAAA;ALshBJ;;AKphBA;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EAEA,2BAAA;ALuhBJ;;AKphBA;EACI,uBAAA;EACA,wBAAA;ALuhBJ;;AKphBA;EACI,cHrDQ;AF4kBZ;;AKnhBA;EACI,eAAA;EACA,cH3DQ;AFilBZ;;AKnhBA;EACG,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;ALshBH;;AKnhBA;EACI,6BAAA;EACA,cAAA;ALshBJ;;AKnhBA;EACI,+CAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;ALshBJ;;AKnhBA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ALshBJ;;AKnhBA;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;ALshBJ;;AKnhBA;EACI,qBAAA;EACA,cAAA;ALshBJ;;AKlhBA;EAAqB,yBHnGZ;AFynBT;;AKlhBA;EACI;IACI,kBAAA;IACA,YAAA;IACA,SAAA;ELqhBN;AACF;AKlhBA;EACI;IACI,kBAAA;IACA,UAAA;IACA,SAAA;ELohBN;AACF;AKjhBA;EACI;IACI,kBAAA;IACA,WAAA;IACA,SAAA;ELmhBN;AACF;AKhhBA;EACI;IACI,kBAAA;IACA,WAAA;IACA,SAAA;ELkhBN;AACF;AM9pBA;EACI,+BAAA;ANgqBJ;;AM7pBA;EAEI,oCAAA;EACA,qBJTO;EIUP,uBAAA;AN+pBJ;;AM5pBA;EACI,YAAA;EACA,mBAAA;AN+pBJ;;AM5pBA;EACI,oCAAA;AN+pBJ;;AM5pBA;EACI,kBAAA;EACA,WAAA;EACA,cJzBO;AFwrBX;;AM5pBA;EACI,SAAA;AN+pBJ;;AM5pBA;EACI,SAAA;AN+pBJ;;AM3pBA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AN8pBJ;;AOtsBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,oBAAA;APysBJ;AOxsBI;EARF;IASI,UAAA;EP2sBJ;AACF;AOzsBE;EACE,WAAA;EACA,6BAAA;EACA,uBAAA;AP2sBJ;AOxsBE;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cLhBC;EKiBD,eLHK;EKIL,mBAAA;EACA,uBAAA;AP0sBJ;AOvsBE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCAAA;APysBJ;AOtsBE;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;APwsBJ;AOrsBE;EACE,QAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;APusBJ;AOrsBE;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;APusBJ;AOrsBE;EACE,kBAAA;EACA,oBAAA;APusBJ;AOrsBE;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;APusBJ;AOrsBE;EACE,uBAAA;EACA,eLxDK;EKyDL,oCAAA;APusBJ;AOrsBE;EACE,sBAAA;EACA,eL7DK;EK8DL,kCAAA;APusBJ;AOpsBE;EACE,eAAA;EACA,WLnFM;EKoFN,2BAAA;APssBJ;AOpsBE;EACE,eAAA;EACA,WLxFM;EKyFN,0CAAA;APssBJ;AOpsBE;EACE,kBAAA;EACA,+CL9FQ;EK+FR,YAAA;EACA,WAAA;APssBJ;AOpsBE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;APssBJ;AOpsBE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;APssBJ;AOnsBE;EACE,0DAAA;APqsBJ;AOnsBE;EACE,aAAA;EACA,sBAAA;APqsBJ;AOnsBE;EACE,wBAAA;EACA,kCAAA;EACA,iCAAA;APqsBJ;AOnsBE;EACE,iBAAA;EACA,2BAAA;APqsBJ;AOnsBE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;APqsBJ;AOlsBE;EACE,wBAAA;EACA,kCAAA;APosBJ;AOlsBE;EACE,aAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;APosBJ;AOlsBE;EACE,kBAAA;EACA,UAAA;APosBJ;AOlsBE;EACE,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;APosBJ;AOjsBE;EACE,aAAA;EACA,cAAA;EACA,uBAAA;APmsBJ;AOhsBE;EACE,WAAA;EACA,cAAA;APksBJ;AO/rBE;EACE,gBAAA;EACA,iBAAA;APisBJ;AO9rBE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;APgsBJ;AO7rBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AP+rBJ;AO5rBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,oBAAA;AP8rBJ;AO3rBE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;AP6rBJ;AO1rBE;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AP4rBJ;AOzrBE;EAEE,sCAAA;EACA,yCAAA;AP0rBJ;AOvrBE;EAEE,uCAAA;EACA,0CAAA;APwrBJ;AOrrBE;EACE,2BAAA;EACA,4BAAA;APurBJ;;AOnrBA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;APsrBF;;AOlrBA;EACE,yBAAA;APqrBF;;AQ96BA;EACI,uBAAA;EACA,eAAA;EACA,iBAAA;ARi7BJ;;AQ96BA,sBAAA;AACA;EACI,eAAA;EACA,gBAAA;ARi7BJ;;AQ76BA;EACE,aAAA;ARg7BF;;AQ76BC,0BAAA;AACA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,wBAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,oCAAA;EACA,uBAAA;EACA,wBAAA;EACA,wCAAA;ARg7BF;;AQ56BA;EACE,0BAAA;EACA,kCAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uDAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AR+6BF;;AQ36BC,4BAAA;AAED;EACE,WAAA;EACA,gBAAA;EACA,oCAAA;AR66BF;;AQ16BA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;AR66BF;;AQ16BA;EACE,yBAAA;AR66BF;;AQ16BA;EACE,yBAAA;AR66BF;;AQ16BA;EACE,2BAAA;AR66BF;;AQ16BA;EACE,uBAAA;EACA,oDAAA;EACA,0BAAA;AR66BF;;AQ16BA;EACE,wBAAA;AR66BF;;AQ16BA;EACE,8BAAA;EACA,gCAAA;AR66BF;;AQ16BA;EACE,gCAAA;AR66BF;;AQ16BA;EACE,gCAAA;AR66BF;;AQ16BA;EACE,gCAAA;AR66BF;;AQ36BA,oBAAA;AAEA;EACE,4BAAA;EACA,iCAAA;AR66BF;;AQ16BA,kBAAA;AACA;EACE,2BAAA;EACA,8BAAA;AR66BF;;AQ16BA,iBAAA;AAEA;EACE,8BAAA;EACA,uBAAA;AR46BF;;AQz6BA,oBAAA;AACA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6CAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AR46BF;;AQt6BA;EACE,sBAAA;EACA,2BAAA;EACA,oCAAA;ARy6BF;;AShkCA;EACI,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,yBPEO;EODP,yBAAA;EACA,4BAAA;EACA,+BAAA;EACA,ePaK;EOZL,eAAA;ATmkCJ;;AShkCA;EACI,kBAAA;EACA,WPTM;EOUN,0BAAA;EACA,uBAAA;EACA,ePIK;EOHL,yCAAA;EACA,sBAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;ATmkCJ;;AUvlCA,cAAA;AAGE;EACA,WAAA;EACA,yBRDS;EQET,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,cAAA;AVwlCF;AUrlCE;EACE,eAAA;AVulCJ;AUplCE;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AVslCJ;AUrlCI;EAPF;IAQI,kBAAA;IACA,WAAA;EVwlCJ;AACF;AUrlCE;EACE,eAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AVulCJ;AUplCE;EACE,cAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AVslCJ;AUnlCE;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AVqlCJ;AUplCI;EARF;IASI,aAAA;EVulCJ;AACF;AUrlCE;EACE,wBAAA;AVulCJ;AUtlCI;EAFF;IAGI,kBAAA;IACA,yBAAA;IACA,oBAAA;EVylCJ;AACF;AUtlCE;EACE,kBAAA;EACA,QAAA;EACA,yBAAA;AVwlCJ;AUvlCI;EAJF;IAKI,kBAAA;IACA,iBAAA;EV0lCJ;AACF;AUvlCE;EACE,eAAA;EACA,cR7EO;AFsqCX;AUtlCE;EACE,cRjFO;EQkFP,qBAAA;AVwlCJ;AUrlCE;EACE,8BAAA;EACA,YAAA;EACA,qBAAA;AVulCJ;;AWhrCA;EACI,iBAAA;EACA,aAAA;EAGA,sBAAA;EAEA,YAAA;EACA,WAAA;AXkrCJ;;AW/qCA;EACI,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;AXkrCJ;;AW/qCA;EACI,WAAA;EACA,WAAA;AXkrCJ;;AW/qCA;EACI,+CTpBQ;ESqBR,YAAA;AXkrCJ;;AW/qCA;EACI,+CTzBQ;ES0BR,YAAA;EACA,6BAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,YAAA;AXkrCJ;;AW/qCA;EACI,kBAAA;EACA,cTtDO;ESuDP,mBAAA;AXkrCJ;;AW/qCA;EACI,cT3DO;ES4DP,4BAAA;AXkrCJ;;AW/qCA;EACI,kBAAA;EACA,YAAA;AXkrCJ;;AW/qCA;EACI,kBAAA;EACA,YAAA;AXkrCJ;;AW9qCA;EACI,gBAAA;AXirCJ;;AW9qCA;EACE,gDTlFW;AFmwCb;;AW9qCA;EACE,yBAAA;AXirCF;;AW9qCA;EACI,yBAAA;AXirCJ;;AW9qCA;EACI,sBAAA;AXirCJ;;AW9qCA;EACI,wBAAA;AXirCJ;;AW9qCA;EACI,qBAAA;AXirCJ;;AW/qCA;EACI,WAAA;EACA,gBAAA;EACA,uBAAA;AXkrCJ;;AW/qCA;EACI,UAAA;AXkrCJ;;AW/qCA;EACI,yBAAA;AXkrCJ;;AW7qCA;EACI,UAAA;AXgrCJ;;AW7qCA;EACI,aAAA;AXgrCJ;;AW7qCA;EACI,2BAAA;AXgrCJ;;AW7qCA;EACI,6BAAA;AXgrCJ;;AW7qCA;EACI,kBAAA;AXgrCJ;;AW7qCA;EACI,UAAA;AXgrCJ;;AW7qCA;EACI,UAAA;AXgrCJ;;AW7qCA;EACC,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AXgrCD;AW9qCC;EACC,4BAAA;EACA,6BAAA;AXgrCF;AW7qCC;EACC,oCAAA;AX+qCF;AW5qCC;EACC,kBAAA;EACA,QAAA;EAAU,0BAAA;EACV,cAAA;EAAe,WAAA;EACf,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,WAAA;AXgrCF;AW7qCC;EAAU,yBAAA;AXgrCX;;AYv2CA;EACE,4FAAA;EACA,4BAAA;EACA,sBAAA;AZ02CF;;AYv2CA;EACE,8BAAA;EACA,gBAAA;EAEA,gBAAA;EACA,iBAAA;AZy2CF;AYv2CE;EAPF;IAQI,eAAA;IACA,gBAAA;EZ02CF;AACF;AYz2CE;EAXF;IAYI,eAAA;IACA,gBAAA;EZ42CF;AACF;AY32CE;EAfF;IAgBI,eAAA;IACA,gBAAA;EZ82CF;AACF;;AY12CA;EACE,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;AZ62CF;;AY12CA;EACG,yBVrCQ;EUsCR,YAAA;EACA,2CVpCS;EUqCT,6BAAA;EACA,iBAAA;EACA,eAAA;AZ62CH;;AY12CA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;AZ62CF;;AY12CA;EACE,+CVjDU;AF85CZ;;AY12CA;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,uBAAA;AZ62CF;;AY12CA;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mDAAA;EACA,mBAAA;AZ62CF;;AY12CA;EACE,oCAAA;AZ62CF;;AYz2CE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AZ42CJ;AYz2CE;EACE,YAAA;EACA,kBAAA;AZ22CJ;;AYt2CE;EACE,UAAA;EACA,YAAA;EAGA,gBAAA;EACA,gBAAA;AZu2CJ;;AYn2CA;EACE,wBAAA;EACA,UAAA;EACA,WAAA;AZs2CF;;AYn2CA;EACE,kBAAA;EACA,oCAAA;EACA,4CAAA;AZs2CF;;Aat9CG;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;Aby9CP;Aav9CG;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;Aby9CP;Aap9CG;EACI,WXbG;EWcH,eAAA;Abs9CP;Aap9CG;EACC,yBAAA;EACA,4BAAA;EACA,0BAAA;Abs9CJ;Aap9CG;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBX7BI;EW8BJ,mBAAA;Abs9CP;Aap9CG;EACI,iBAAA;EACA,YAAA;EACA,iCAAA;EACA,uBAAA;EACA,8BAAA;Abs9CP;Aan9CG;EAEK,iCAAA;Abo9CR;Aal9CG;EACI,kBAAA;EACA,QAAA;Abo9CP;Aal9CG;EACI,kBAAA;EACA,WAAA;Abo9CP;;AcvgDA,kBAAA;AAEA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AdygDJ;;ActgDA;EACI,WAAA;EACA,YAAA;AdygDJ;;ActgDA;EACI,cZZO;EYaP,iBAAA;EACA,eAAA;AdygDJ;;ActgDA;EACI,0BAAA;EACA,YAAA;AdygDJ;;ActgDA;EACI,SAAA;EACA,kBAAA;EACA,QAAA;EAEA,2BAAA;AdygDJ;;ActgDA;EACI,sBAAA;EACA,uBAAA;AdygDJ;;ActgDA;EACI,cZ5BQ;AFqiDZ;;AcrgDA;EACI,eAAA;EACA,cZlCQ;AF0iDZ;;AcrgDA;EAAqB,yBZnCX;AF4iDV;;AevjDI;EACI,+BAAA;EACA,iBAAA;Af0jDR;;AgB7jDA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AhBgkDJ;AgBzjDA;EAEI,yBAAA;AhB0jDJ;;AgBvjDA;EAEI,yBAAA;EACA,uBAAA;AhByjDJ;;AgBtjDA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cd/BO;EcgCP,eAAA;EACA,iBAAA;AhByjDJ;AgBvjDI;EACI,eAAA;AhByjDR;;AgBrjDA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AhBwjDJ;;AgBtjDA;EAEG,cdnDQ;AF2mDX;;AgBrjDA;EAEI,cdxDO;EcyDP,gBAAA;AhBujDJ;;AgBpjDA;EAEI,0BAAA;EACA,mBAAA;EACA,gBAAA;AhBsjDJ;;AgBnjDA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBdvEO;EcwEP,kBAAA;EACA,UAAA;EACA,UAAA;AhBsjDJ;AgBrjDI;EARJ;IASQ,UAAA;EhBwjDN;AACF;AgBvjDI;EAXJ;IAYQ,UAAA;EhB0jDN;AACF;;AgBvjDA;EAEI,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,UAAA;AhByjDJ;AgBxjDI;EAPJ;IAQQ,UAAA;EhB2jDN;AACF;AgB1jDI;EAVJ;IAWQ,UAAA;EhB6jDN;AACF;AgB5jDI;EAbJ;IAcQ,UAAA;EhB+jDN;AACF;;AgB5jDA;EAEI,aAAA;EACA,yBAAA;EACA,YAAA;AhB8jDJ;AgB7jDI;EALJ;IAMQ,UAAA;EhBgkDN;AACF;;AgB5jDA,cAAA;AAEA,WAAA;AACA;EACI,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AhB8jDJ;AgBzjDA;EACI,aAAA;AhB2jDJ;;AgBxjDA;EACI,2BAAA;EACA,cAAA;AhB2jDJ;;AgBxjDA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AhB2jDJ;;AgBxjDA;EACI,kBAAA;EACA,WAAA;AhB2jDJ;;AgBzjDA;EACI,eAAA;EACA,cd3IQ;Ec4IR,iBAAA;AhB4jDJ;AgB3jDI;EAJJ;IAKQ,kBAAA;EhB8jDN;AACF;;AgB5jDA;EACI,0BAAA;EACA,cd9IO;AF6sDX;;AgB5jDA;EACI,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AhB+jDJ;;AgB7jDA;EACI,cAAA;EACA,cdxJS;EcyJT,8BAAA;AhBgkDJ;;AgB9jDA;EACI,eAAA;EACA,iBAAA;EACA,cdpKQ;AFquDZ;;AgB9jDA;EACI,iBAAA;EACA,cdzKQ;AF0uDZ;;AgB9jDA;EAEI,cdtLO;EcuLP,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AhBgkDJ;AgB/jDI;EAPJ;IAQQ,gBAAA;EhBkkDN;AACF;;AgB9jDA;EAEI,eAAA;EACA,yBAAA;EACA,SAAA;AhBgkDJ;;AgB7jDA;EAEI,kBAAA;AhB+jDJ;;AgB5jDA;EAEI,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;AhB8jDJ;;AgB5jDA;EAEI,eAAA;EACA,iBAAA;EACA,cdhNQ;EciNR,kBAAA;AhB8jDJ;;AgB5jDA;EACI,eAAA;EACA,cd9MM;AF6wDV;;AgB5jDA;EACI,iBAAA;AhB+jDJ;;AgB3jDA,WAAA;AAEA;EACI,kBAAA;EACA,mBAAA;AhB6jDJ;;AgB1jDA;EACI,kBAAA;EACA,mBAAA;AhB6jDJ;;AgB1jDA;EACI,kBAAA;EACA,mBAAA;AhB6jDJ;;AgBxjDA;EAEI,gBAAA;EACA,WAAA;AhB0jDJ;;AgBxjDA;EAEI,uBAAA;AhB0jDJ;;AgBvjDA;EACI,gBAAA;EACA,eAAA;AhB0jDJ;;AgBvjDA;EAEI,yBAAA;AhByjDJ;;AgBtjDA;EAEI,eAAA;AhBwjDJ;;AgBrjDA;EAEI,YAAA;AhBujDJ;;AgBjjDA;EAEI,kBAAA;EACA,WAAA;AhBmjDJ;;AgBhjDA,6BAAA;AACA;EACI,gDAAA;EACA,0BAAA;AhBmjDJ;;AgBhjDA;EACI,yBAAA;EACA,oCAAA;AhBmjDJ;;AgB9iDA;EACI,mBAAA;EACA,qCAAA;AhBijDJ;;AgB9iDA;EACI,sBAAA;EACA,mCAAA;AhBijDJ;;AgB9iDA;EACI,6BAAA;AhBijDJ;;AgB9iDA,kCAAA;AAGA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cd3TQ;AF02DZ;;AgBziDA;EACI,kBAAA;EACA,cAAA;EAEA,UAAA;EACA,eAAA;AhB2iDJ;;AgBxiDA;EACI,gBAAA;AhB2iDJ;;AgBxiDA;EACI,wBAAA;AhB2iDJ;;AgBviDA;EAEI,kBAAA;EACA,WAAA;AhByiDJ;;AgBtiDA;EACI,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;AhByiDJ;;AiB/4DA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AjBk5DF;;AiB/4DA;EACE,iBAAA;EACA,cAAA;AjBk5DF;;AiB/4DA;EACE,kBAAA;EACA,cAAA;AjBk5DF;;AAh5DA;EACE,8BAAA;AAm5DF","sourcesContent":[".fs-10 { font-size: 10px;}\n.fs-11 { font-size: 11px;}\n.fs-12 { font-size: 12px;}\n.fs-13 { font-size: 13px;}\n.fs-14 { font-size: 14px;}\n.fs-15 { font-size: 15px;}\n.fs-16 { font-size: 16px;}\n.fs-17 { font-size: 17px;}\n.fs-18 { font-size: 18px;}\n.fs-19 { font-size: 19px;}\n.fs-20 { font-size: 20px;}\n.fs-21 { font-size: 21px;}\n.fs-22 { font-size: 22px;}\n.fs-23 { font-size: 23px;}\n.fs-24 { font-size: 24px;}\n.fs-25 { font-size: 25px;}\n.fs-26 { font-size: 26px;}\n.fs-27 { font-size: 27px;}\n.fs-28 { font-size: 28px;}\n.fs-29 { font-size: 29px;}\n.fs-30 { font-size: 30px;}\n.fs-31 { font-size: 31px;}\n.fs-32 { font-size: 32px;}\n.fs-33 { font-size: 33px;}\n\n\n.bold {font-weight: bold;}","@import './variables';\n@import './fonts.scss';\n@import './colors.scss';\n@import './header.scss';\n@import './homepage/landing.scss';\n@import './homepage/container.scss';\n@import './login.scss';\n@import './sidePanel.scss';\n@import './modificationBuiltin.scss';\n@import './shared.scss';\n@import './footer.scss';\n@import \"./app.scss\";\n@import \"./simulation.scss\";\n@import \"./zoning.scss\";\n@import './infoPage.scss';\n@import \"./errors.scss\";\n@import \"./economicViability.scss\";\n@import \"./chart.scss\";\n\nbody, html { \n  font-family: Barlow !important;\n}\n\n//@media only screen and (max-width: 950px) {\n//  body {\n//    padding-top: 60px;\n//  }\n//}","\n.light-grey { color: $mid-grey; }\n.clr-text {color: gray !important;}\n.black {color: $black;}\n\n.bg-white {background-color:'white'}\n.bg-Dgray {background-color: $dark-grey !important;}","// Colors\n$primary : #43B02A;\n$secondary:#702082;\n$light-green:#43B02A3B;\n$light-grey:#53565A10;\n$mid-grey:gray;\n$dark-grey:#53565A;\n$red:#E03C31;\n$black:#000000;\n$light-purple:#70208208;\n$light-text:#525252;\n$bg-grey:#F5F5F5;\n$bg-grey2:#F3F3F3;\n\n// Card-Map\n$card-text:#9AA1A9;\n$card-text-2:#9CA3AB;\n$card-bar:#B3B4B6;\n$slider-text:#53565A7E;\n\n// Font\n$font-11:11px;","/* Headers CSS */\n.header-main {\n    position: fixed;\n    top: 0;\n    left: 0;\n    background-color: white;\n    z-index: 1000;\n    box-shadow: 0px 3px 6px #00000029;\n}\n\n\n.header-left {\n    font-size: 31px;\n    color: $mid-grey;\n    cursor: pointer;\n    font-weight: bold;\n    position: relative;\n}\n.header-right {\n    font-size: 19px;\n    color:$primary;\n    cursor: pointer;\n    font-weight: bold;\n    position: relative;\n}\n.header-left-small-screens {\n    font-size: 19px;\n}\n\n.header-small-screens {\n    font-size: 14px;\n}\n\n.header-login {\n    padding: 3px 30px 3px 30px;\n    border: 1px solid $primary;\n    color: $primary;\n    background-color: white;\n    border-radius: 15px;\n    cursor: pointer;\n}\n.header-second {\n    color: $dark-grey;\n    font-size: 19px;\n    font-weight: 500;\n}\n\n.pointer { cursor: pointer; }\n\n.highlight {\n    text-decoration-line: underline;\n    text-decoration-color: $primary;\n}\n","\n@import '../variables';\n\n\n/* Landing CSS */\n\nhtml {\n    scroll-behavior: smooth;\n}\n\n.landing-image {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: start;\n    justify-content: end;\n    background-image: url(../../../assets/used/map.jpg);\n    background-size: cover;\n}\n\n.landing-image-mask {\n    background-image: url(../../../assets/used/homepage-line.svg);\n    position: absolute;\n    width: 100%;\n    height: 20%;\n    bottom: 0;\n    left: 0;\n    z-index: 3;\n    background-size: cover;\n}\n\n.trace-sideline {\n    width: 58%;\n    height: 70%;\n    position: absolute;\n    bottom: -50%;\n    left: -47%;\n    z-index: 4;\n\n    @media (max-width: 1400px) {\n        width: 50em;\n        height: 70%;\n        bottom: -50%;\n        left: -53%;\n    }\n    @media (max-width: 1250px) {\n        width: 42em;\n        height: 70%;\n        bottom: -50%;\n        left: -58%;\n    }\n    @media (max-width: 960px) {\n        width: 70%;\n        height: 103%;\n        bottom: -50%;\n        left: -58%;\n    }\n    @media (max-width: 660px) {\n        display: none;\n    }\n}\n\n.trace-right-line {\n    width: 40%;\n    height: 22%;\n    position: absolute;\n    bottom: 64%;\n    right: 0%;\n    /* transform: rotateZ(120deg); */\n    z-index: 1;\n\n    @media (max-width: 1250px) {\n        width: 32rem;\n        height: 44rem;\n        bottom: 48%;\n    }\n    @media (max-width: 960px) {\n        width: 22rem;\n        height: 32rem;\n        bottom: 51%;\n    }\n    @media (max-width: 660px) {\n        display: none;\n    }\n    // @media (max-width: 1100px) {\n    //     display: none;\n    // }\n}\n\n.landing-bottom-circle {\n    position:absolute;\n    bottom: -15px;\n    background-color: $red;\n    border-radius: 50%;\n    padding: 5px;\n    height: 50px;\n    width: 50px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    line-height: 0.1;\n    cursor: pointer;\n}\n\n.bottom-icon {\n    color: white;\n    font-weight: bold;\n    font-size: 20px;\n    padding-top: 15px !important;\n}\n\n@keyframes arrowDown {\n    0%   {position: relative}\n    100% {padding-top: 10px;}\n}\n\n.arrow-icon {\n  padding-right: 0.5px;\n  &:hover {\n    animation-name: arrowDown;\n    animation-duration: 1s;\n  }\n}\n\n.landing-page-container {\n    height: 100vh;\n}\n\n.landing-container {\n    z-index: 100;\n    margin-top: 12%;\n    max-width: 55%;\n    //max-height: 300px;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    display: flex;\n    padding: 20px 30px 30px 30px;\n    border-radius: 10px;\n    background:rgba(255,255,255, 0.9);\n    gap: 5px;\n}\n\n.landing-container-heading {\n    font-size: 32px;\n    font-weight: bold;\n    padding: 0 10px;\n}\n\n.landing-font {\n    font-size: 15px;\n    color: $dark-grey;\n}\n\n.search-bar {\n    height: 40px;\n}\n\n.landing-btn {\n    padding: 7px 15px 7px 15px;\n    height: 40px;\n    border: none;\n    color: white;\n    background-color: $primary;\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n}\n\n.landing-btn-container\n{\n    display: flex;\n    justify-content: center;\n}\n\n.landing-input {\n    height: 100%;\n    outline-style: none;\n    box-shadow: none;\n    border-color: transparent;\n    border: none;\n    text-indent: 10px;\n    border-top-left-radius: 20px;\n    border-bottom-left-radius: 20px;\n    border:1px solid lightgrey;\n}\n\n.landing-input-size {\n    width: 100%;\n    font-size: xx-small !important;\n}\n\n@media only screen and (min-width: 800px) {\n    .landing-input-size {\n        width: 300px;\n    }\n}\n\n.right-round {\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n}\n\n.search-bottom {\n    font-weight: bolder;\n    font-size: 16px;\n    text-decoration-line: underline;\n    color:$secondary;\n}\n\n.listbox {\n    cursor: pointer;\n    margin-top: 40px;\n    width: 300px;\n    padding: 0;\n    z-index: 1;\n    position: absolute;\n    list-style: none;\n    background-color: #f3f3f3;\n    overflow: auto;\n    max-height: 200px;\n    border: 1px solid rgba(0,0,0,.25);\n  }\n\n.text-small {\n    font-size: small;\n}\n\n/* FAQ CSS */\n\n.faq-heading {\n    color:$secondary;\n    font-weight: bold;\n    font-size: 35px;\n}\n\n/* Loader CSS */\n\n.center-fixed {\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    position: fixed;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 111;\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.start-button {\n    border-radius: 20px;\n    border: 0;\n    color: white;\n    font-weight: bold;\n    padding: 5px 20px 5px 20px;\n}\n\n.video-button {\n    z-index: 3;\n    position: absolute;\n    bottom: 10%;\n    left: 45%;\n    border-radius: 40px;\n    border: 0;\n    color: white;\n    background-color: #e10001;\n    font-size: 30px;\n    //width: 15%;\n    //height: 8%;\n    font-weight: bold;\n    padding: 5px 20px 5px 20px;\n}\n\n.video-icon {\n    padding-bottom: 2px;\n    margin-left: 8px;\n}\n\n.section2-lp {\n    margin-left: 12%;\n    margin-right: 12%;\n\n    @media (max-width: 768px) {\n        margin-left: 9%;\n        margin-right: 9%;\n    }\n    @media (max-width: 600px) {\n        margin-left: 8%;\n        margin-right: 8%;\n    }\n}\n\n.house-img {\n    width: 90%;\n    height: 90%;\n}\n\n.house-img-last-section-1 {\n    width: 20%;\n    height: 100%;\n}\n\n.house-img-last-section-2 {\n    width: 30%;\n    height: 100%;\n}\n\n.house-img-last-section-3 {\n    width: 40%;\n    height: 100%;\n}\n\n.en-center {\n    display: flex;\n    justify-content: center;\n}\n\n.w-80p {\n    width: 80% !important;\n}\n/* Color Classes */\n\n.primary-clr { color: $primary; }\n.secondary-clr { color: $secondary; }\n\n\n@media screen and (max-width: 1400px) {\n    .landing-container {\n        max-width: 400px;\n        padding: 10px 15px 15px 15px;\n    }\n    .landing-container-heading {\n        font-size: 20px;\n    }\n    .landing-font {\n        font-size: 12px;\n    }\n    .video-button {\n        font-size: 20px;\n    }\n    .video-icon {\n        width: 30px;\n        height: 40px;\n    }\n}","/* Containers CSS*/\n\n.container-image {\n    width: 100%;\n    height: 100%;\n}\n\n.container-line-img {\n    position: relative;\n    bottom: 5.5%;\n    left: 0px;\n}\n\n.container-heading {\n    color:$secondary;\n    font-weight: bold;\n    font-size: 35px;\n}\n\n.container-heading-2 {\n    font-size: 28px;\n    color:$secondary;\n    font-weight: bold;\n}\n\n.side-margin {\n    margin-left: 150px;\n    margin-right: 150px;\n}\n.container-content {\n    display: flex;\n    justify-content: center;\n    font-size: 17px;\n    color: $dark-grey;\n    text-align: left !important;\n}\n\n.center-text {\n    text-align: center !important;\n}\n\n.container-content-btn {\n    padding: 7px 20px 7px 20px !important;\n    border: 1px solid $red !important;\n    color: white;\n    background-color: $red;\n    border-radius: 30px !important;\n    cursor: pointer;\n}\n.container-vertical-center {\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.container-grid-img {\n    width: 127px !important;\n    height: 127px !important;\n}\n\n.container-grid-head {\n    color: $light-text;\n}\n\n\n.container-grid-para {\n    font-size: 14px;\n    color: $light-text;\n}\n\n.container-grid-btn {\n   font-size: 15px;\n   color: $red !important;\n   font-weight: bold;\n   text-decoration-line: underline;\n   cursor: pointer;\n}\n\n.circled-border {\n    border: 1px solid transparent;\n    display: block;\n}\n\n.circled-border:hover {\n    border: 1px solid $light-grey;\n    border-radius: 50%;\n    cursor: pointer;\n    width: 100%;\n}\n\n.example-top-image-right {\n    position: relative;\n    margin-left: 29%;\n    margin-top: -148%;\n}\n\n.example-top-image-left {\n    position: relative;\n    margin-top: -148%;\n    margin-left: -28%;\n}\n\nul.green-list {\n    list-style-type: disc;\n    color: #66B654;\n}\n\n\n.conatiner-bg-grey { background-color: $bg-grey}\n\n\n\n@media only screen and (max-width: 1150px) {\n    .container-line-img {\n        position: relative;\n        bottom: 5.3%;\n        left: 0px;\n    }\n}\n\n@media only screen and (max-width: 960px) {\n    .container-line-img {\n        position: relative;\n        bottom: 3%;\n        left: 0px;\n    }\n}\n\n@media only screen and (max-width: 850px) {\n    .container-line-img {\n        position: relative;\n        bottom: 5px;\n        left: 0px;\n    }\n}\n\n@media only screen and (max-width: 600px) {\n    .container-line-img {\n        position: relative;\n        bottom: 2px;\n        left: 0px;\n    }\n}\n\n","\n@import './variables';\n\n.login-height {\n    min-height: calc(100vh - 125px);\n}\n\n.login-btn {\n\n    background-color: $primary !important;\n    border-color: $primary;\n    color: white !important;\n}\n\n.login-text {\n    color: white;\n    white-space: nowrap;\n}\n\n.login-bg {\n    background-color: $primary !important;\n}\n\n.icon-auth {\n    position: absolute;\n    right: 10px;\n    color: $primary;\n}\n\n.password-icon-register{\n    top: 45px;\n}\n\n.password-icon-login{\n    top:12px;\n\n}\n\n.invalid-field-label{\n    font-size: 80%;\n    margin-top:5px;\n    color: #dc3545;\n}",".sidepanel {\n  &-container {\n    position: relative;\n    display: block;\n    float: right;\n    right: 45px;\n    top: 20px;\n    width: 100% !important;\n    padding-bottom: 10px;\n    @media screen and (max-width: 600px) {\n      right: 0px;\n    }\n  }\n  &-panel {\n    width: 100%;\n    border-top: 4px solid $primary;\n    background-color: white;\n  }\n\n  &-button {\n    border: 1px solid $red;\n    padding: 5px 15px 5px 15px;\n    text-align: center;\n    color: $red;\n    font-size: $font-11;\n    border-radius: 25px;\n    background-color: white;\n  }\n\n  &-ful-btn {\n    border: 1px solid $red;\n    text-align: center;\n    font-size: 16px;\n    font-weight: normal;\n    font-family: Barlow;\n    color: rgb(0, 0, 0);\n    border-radius: 5px;\n    border-color: green;\n    background-color: white !important;\n  }\n\n  &-input {\n    min-width: 100%;\n    padding: 7px;\n    outline-style: none;\n    box-shadow: none;\n    border-radius: 20px;\n    border-color: transparent;\n    border: none;\n    text-indent: 10px;\n    border: 1px solid lightgrey;\n  }\n\n  &-search {\n    top: 8px;\n    right: 15px;\n    position: absolute;\n    cursor: pointer;\n    bottom: 100px;\n  }\n  &-close-icon {\n    position: absolute;\n    top: 32px;\n    left: -55px !important;\n  }\n  &-with-down {\n    position: absolute;\n    top: 93px !important;\n  }\n  &-hide-panel {\n    position: absolute;\n    right: -66px;\n    top: 40px;\n    transform: rotate(180deg);\n  }\n  &-future {\n    color: white !important;\n    font-size: $font-11;\n    background-color: $dark-grey !important;\n  }\n  &-current {\n    color: $mid-grey !important;\n    font-size: $font-11;\n    background-color: white !important;\n  }\n\n  &-chevron {\n    font-size: 15px;\n    color: $mid-grey;\n    transform: translateY(-3px);\n  }\n  &-chevron-rotate {\n    font-size: 15px;\n    color: $mid-grey;\n    transform: translateY(-3px) rotate(180deg);\n  }\n  &-inside {\n    position: relative;\n    background-color: $light-grey;\n    height: 100%;\n    width: 100%;\n  }\n  &-sm-input {\n    width: 100%;\n    border-radius: 5px;\n    border: 1px solid grey;\n  }\n  &-input-error {\n    width: 100%;\n    border-radius: 5px;\n    border: 1px solid red;\n  }\n\n  &-section:hover {\n    background-color: $light-grey !important;\n  }\n  &-radioList {\n    display: flex;\n    flex-direction: column;\n  }\n  &-vertical {\n    display: flex !important;\n    justify-content: center !important;\n    flex-direction: column !important;\n  }\n  &-multi-label {\n    padding-left: 35%;\n    transform: translateY(-2px);\n  }\n  &-multi-label-span {\n    border-radius: 50%;\n    font-size: 14px;\n    background: white;\n    padding: 1px 9px;\n    //border: 1px solid black\n  }\n  &-H-center {\n    display: flex !important;\n    justify-content: center !important;\n  }\n  &-mandatory {\n    display: flex;\n    flex-direction: row-reverse;\n    width: 100%;\n    font-size: 13px;\n    color: gray;\n  }\n  &-add {\n    position: absolute;\n    top: -13px;\n  }\n  &-add-icon {\n    padding: 0px 5px 1.5px 5px;\n    color: white;\n    background: #53565a;\n    border-radius: 50%;\n  }\n\n  &-slider {\n    display: flex;\n    margin: 0 auto;\n    justify-content: center;\n  }\n\n  &-label {\n    width: 50px;\n    display: block;\n  }\n\n  &-input[type=\"checkbox\"] {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  &-li {\n    flex: 0 1 33%;\n    list-style: none;\n    position: relative;\n  }\n\n  &-li:first-child:before {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    width: 20%;\n    background: black;\n    top: 12px;\n    right: 100%;\n  }\n\n  &-li:after {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    width: 100%;\n    background: black;\n    top: 12px;\n    left: 25% !important;\n  }\n\n  &-li:last-child:after {\n    content: \"\";\n    position: absolute;\n    height: 1px;\n    width: 20%;\n    background: black;\n    top: 12px;\n    left: 100%;\n  }\n\n  &-btn-center {\n    background-color: #9ca5b1;\n    padding: 3px 20px;\n    color: white;\n    font-size: 15px;\n    border: 1px solid white;\n  }\n\n  &-btn-left {\n    @extend .sidepanel-btn-center;\n    border-top-left-radius: 5px !important;\n    border-bottom-left-radius: 5px !important;\n  }\n\n  &-btn-right {\n    @extend .sidepanel-btn-center;\n    border-top-right-radius: 5px !important;\n    border-bottom-right-radius: 5px !important;\n  }\n\n  &-active-border {\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n  }\n}\n\n.sidepanel-download-button{\n  background-color: #DC3B30;\n  border-radius: 30px;\n  float: right;\n  color: #fff;\n  border: none;\n  font-size: 15px;\n  padding: 6px 15px;\n  margin-top: -14px;\n\n}\n\n.sidepanel-download-button:hover{\n  background-color: #b13128;\n}","h4, .h4 {\n    /* font-size: 1.5rem; */\n    font-size: 15px;\n    font-weight: bold;\n}\n\n/* Multicolor Labels */\nsmall, .small {\n    font-size: 11px;\n    font-weight: 400;\n  }\n\n  \ntextarea:focus, input:focus {\n  outline: none;\n}\n\n /* Material UI Text-Field*/\n .MuiInputBase-input {\n  font: inherit;\n  color: currentColor;\n  width: 250px !important;\n  border: 0;\n  height: 2em;\n  margin: 0;\n  display: block;\n  padding: 20px !important;\n  min-width: 0;\n  background: white !important;  \n  box-sizing: content-box;\n  animation-name: mui-auto-fill-cancel;\n  letter-spacing: inherit;\n  animation-duration: 10ms;\n  -webkit-tap-highlight-color: transparent;\n}\n\n\n.MuiInputBase-root {\n  color: rgba(0, 0, 0, 0.87);\n  background-color: white !important;\n  cursor: text;\n  width: 285px;\n  height: 59px !important;\n  padding-top: 4px !important;\n  display: inline-flex;\n  position: relative;\n  font-size: 1rem;\n  box-sizing: border-box;\n  align-items: center;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  line-height: 1.1876em;\n  letter-spacing: 0.00938em;\n}\n\n\n /* Material UI DatePickers */\n\n.MuiPickersDay-daySelected {\n  color: #fff;\n  font-weight: 500;\n  background-color: $primary !important;\n}\n\n.MuiPickersToolbar-toolbar {\n  height: 100px;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: center;\n  background-color: $primary !important;\n}\n\n.MuiButton-textPrimary {\n  color: $primary !important;\n}\n\n.MuiTypography-colorPrimary {\n  color: $primary !important;\n}\n\n.MuiFilledInput-inputAdornedEnd {\n  margin-top: 12px !important;\n}\n\n.MuiInputLabel-shrink {\n  z-index: 999 !important;\n  transform: translate(0, 18px) scale(0.75) !important;\n  transform-origin: top left;\n}\n\n.MuiFormHelperText-root {\n  display: none !important;\n}\n\n.MuiTableCell-root {\n  border-bottom: none !important;\n  font-family: 'Barlow' !important;\n}\n\n.MuiTypography-body1 {\n  font-family: 'Barlow' !important;\n}\n\n.MuiFormLabel-root {\n  font-family: 'Barlow' !important;\n}\n\n.MuiButton-root {\n  font-family: 'Barlow' !important;\n}\n/* SELECT DROPDOWN */\n\n.MuiMenu-paper {\n  max-height: 400px !important;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* MENU DROPDOWN */\n.MuiList-padding {\n  padding-top: 8px !important;\n  padding-bottom: 0px !important;\n}\n\n/* AUTOCOMPLETE */\n\n.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot {\n  padding-right: 56px !important;\n  width: 285px !important;\n}\n\n/* MODAL INFO PAGE */\n.react-responsive-modal-modal {\n  min-width: 90%;\n  display: inline-block;\n  text-align: left;\n  vertical-align: middle;\n  background: #ffffff;\n  box-shadow: 0 12px 15px 0 rgb(0 0 0 / 25%);\n  margin: 1.2rem;\n  padding: 1.2rem;\n  position: relative;\n  overflow-y: auto;\n}\n\n\n// FORM SELECT \n\n.form-select {\n  width: auto !important; \n  box-shadow: none !important;\n  border: 1px solid #ced4da !important;\n}\n",".rounded-span {\n    text-align: center;\n    color: white;\n    padding: 3px 20px 3px 20px;\n    background-color: $dark-grey;\n    border: 1px solid $dark-grey;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n    font-size: $font-11;\n    cursor: pointer;\n}\n\n.rounded-span2 {\n    text-align: center;\n    color: $mid-grey;\n    padding: 3px 15px 3px 15px;\n    background-color: white;\n    font-size: $font-11;\n    border-left: 1px solid $dark-grey !important;\n    border: 1px solid $mid-grey;\n    border-top-right-radius: 15px;\n    border-bottom-right-radius: 15px;\n    cursor: pointer;\n}","\n\n/* Footer CSS*/\n\n.footer {\n  &-container {\n  width: 100%;\n  background-color: $dark-grey;\n  color:white;\n  position: relative !important;\n  bottom: 0 !important;\n  display: block;\n  }\n\n  &-fixed {\n    position: fixed\n  }\n  \n  ul {\n    padding:0;\n    list-style:none;\n    text-align:right;\n    font-size:18px;\n    line-height:1.6;\n    margin-bottom:0;\n    @media (max-width: 500px) {\n      text-align: center;\n      width: 100%;\n    }\n  }\n  \n  li {\n    padding:0 10px;\n    color: white !important;\n    opacity: 1;\n    margin-top: 5px;\n  }\n  \n  ul a {\n    color:inherit;\n    text-decoration:none;\n    color: white;\n    font-size: 14px;\n  }\n  \n  &-copyright {\n    margin-left: 20px;\n    text-align:right;\n    align-self: center;\n    font-size:13px;\n    color:lightgray;\n    margin-bottom:0;\n    margin-top: 3px;\n    @media (max-width: 500px) {\n      display: none;\n    }\n  }\n  &-copyright-responsive {\n    display: none !important;\n    @media (max-width: 500px) {\n      text-align: center;\n      display: block !important;\n      padding-bottom: 10px;\n    }\n  }\n\n  &-company-div {\n    position: relative;\n    top: 50%;\n    transform: translateY(0%);\n    @media (max-width: 500px) {\n      text-align: center;\n      padding-top: 10px;\n    }\n  }\n\n  &-company {\n    cursor: pointer;\n    color: $primary;\n  }\n\n  &-company:hover {\n    color: $primary;\n    text-decoration: none;\n  }\n\n  &-vl {\n    border-left: 2px solid $primary;\n    height: 14px;\n    display: inline-block;\n  }\n\n}",".app-content-wrapper {\n    min-height: 100vh;\n    display: flex;\n    -ms-flex-direction: column;\n    -webkit-flex-direction: column;\n    flex-direction: column;\n    //-webkit-box-flex: 1;\n    flex-grow: 1;\n    width: 100%;\n}\n\n.simulation-card {\n    border-top: 4px solid $primary;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    margin-top: 100px;\n}\n\n.zoning-card {\n    width: 100%;\n    height: 50%;\n}\n\n.simulation-card-header {\n    background-color: $light-grey;\n    height: 60px;\n}\n\n.info-card {\n    background-color: $light-grey;\n    height: 100%;\n    padding-left: 10px !important;\n}\n\n.small-card {\n    width: 150px;\n}\n\n.medium-card {\n    width: 200px;\n}\n\n.large-card {\n    width: 250px;\n}\n\n.x-large-card {\n    width: 375px;\n}\n\n.half-card {\n    width: 312px;\n}\n\n.full-card {\n    width: 648px;\n}\n\n.inner-card-text {\n    font-size: x-large;\n    color: $dark-grey;\n    font-weight: bolder;\n}\n\n.card-title {\n    color: $dark-grey;\n    font-weight: bold !important;\n}\n\n.two-unit-right {\n    position: relative;\n    bottom: 22px;\n}\n\n.two-unit-left {\n    position: relative;\n    bottom: 22px;\n}\n\n\n.units-text {\n    font-size: small;\n}\n\n.bg-green {\n  background-color: $light-green;\n}\n\n.bg-dark-green {\n  background-color: #66b554;\n}\n\n.text-green {\n    color: $primary !important;\n}\n\n.bg-grey {\n    background-color: gray;\n}\n\n.bg-orange {\n    background-color: orange;\n}\n\n.text-red {\n    color: red !important;\n}\n.ellipses {\n    width: 12em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.w-90percent {\n    width: 90%;\n}\n\n.cyan-bg {\n    background-color: #e8e8e8;\n    //backdrop-filter: blur(1px);\n    //backdrop-filter: opacity(20%);\n}\n\n.w-55percent {\n    width: 55%;\n}\n\n.h-150 {\n    height: 150px;\n}\n\n.text-small {\n    font-size: small !important;\n}\n\n.text-x-small {\n    font-size: x-small !important;\n}\n\n.overflow-y {\n    overflow-y: scroll;\n}\n\n.width-90pc {\n    width: 90%;\n}\n\n.width-10pc {\n    width: 10%;\n}\n\n#close {\n\toverflow: hidden;\n\tposition: relative;\n\tborder: none;\n\tpadding: 0;\n\twidth: 2em; //height: 2em;\n\tborder-radius: 20%;\n\tbackground: transparent;\n\tcolor: #555555;\n\tfont: inherit;\n\ttext-indent: 100%;\n\tcursor: pointer;\n\t\n\t&:focus {\n\t\toutline: solid 0 transparent;\n\t\tbox-shadow: 0 0 0 2px #a9aaaa\n\t}\n\t\n\t&:hover {\n\t\tbackground: rgba(145, 151, 150, 0.1)\n\t}\n\t\n\t&:before, &:after {\n\t\tposition: absolute;\n\t\ttop: 15%; left: calc(50% - .0625em);\n\t\twidth: .125em; height: 70%;\n\t\tborder-radius: .125em;\n\t\ttransform: rotate(45deg);\n\t\tbackground: currentcolor;\n\t\tcontent: ''\n\t}\n\t\n\t&:after { transform: rotate(-45deg); }\n}",".bg-images {\n  background: url(../../assets/used/map-0.35.jpg), url(../../assets/used/homepage-line-inverted.svg);\n  background-blend-mode: color;\n  background-size: cover;\n}\n\n.simulation-page {\n  min-height: calc(100vh - 80px);\n  margin-top: 80px;\n\n  margin-left: 15%;\n  margin-right: 15%;\n\n  @media (max-width: 576px) {\n    margin-left: 2%;\n    margin-right: 2%;\n  }\n  @media (max-width: 768px) {\n    margin-left: 4%;\n    margin-right: 4%;\n  }\n  @media (max-width: 992px) {\n    margin-left: 7%;\n    margin-right: 7%;\n  }\n\n}\n\n.simulation-page h2 {\n  text-align: center !important;\n  font-weight: bold;\n  font-size: 28px;\n  color: #53565A;\n  margin-bottom: 20px;\n  text-shadow: #53565A;\n}\n\nth {\n   background-color:$primary;\n   color:white;\n   border-color: $light-grey;\n   text-align: center !important;\n   font-weight: bold;\n   font-size: 20px;\n  }\n  \ntd, th {\n  border: 1px solid none;\n  padding: 8px;\n  text-align: center;\n}\n\ntr:nth-child(even) {\n  background-color: $light-grey;\n}\n\n.MuiTableCell-head {\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 500;\n  line-height: 1.5rem;\n  font-weight: bold !important;\n  font-size: 17px !important;\n  color: white !important;\n}\n\n.new-sim-button {\n  background-color: #702082 !important;\n  border: none;\n  padding: 12px 22px;\n  border-radius: 28px;\n  color: #fff;\n  font-size: 14px;\n  box-shadow: 0px 3px 6px #00000029;\n  margin-bottom: 20px;\n}\n\n.new-sim-button:hover {\n  background-color: #912aa8 !important;\n}\n\n.simulationpanel {\n  &-hide-panel {\n    position: absolute;\n    left: -10px;\n    top: 140px;\n    // transform: rotate(180deg);\n  }\n  &-small-screens {\n    height: 40vh;\n    overflow-y: scroll;\n  }\n}\n\n.resultpanel {\n  &-small-screens {\n    width: 80%;\n    height: 30vh;\n    // max-width: 80%;\n    // max-height: 30vh;\n    overflow-y: auto;\n    overflow-x: auto;\n  }\n}\n\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 7px;\n  height: 9px;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n\n  // maxWidth: '60vw', width: '100%',",".zoning {\n   &-fields {\n       display: flex;\n       align-items: center !important;\n       justify-content: center;\n       flex-direction: row;\n       min-height: calc(100vh - 29px);\n       margin-top: 50px;\n   }\n   &-upload-div {\n       display: flex;\n       align-items: center;\n       justify-content: center;\n   }\n   &-upload-msg {\n       @extend .zoning-upload-div;\n   }\n   &-msg-text {\n       color: $mid-grey;\n       font-size: 16px;\n   }\n   &-msg-text2 {\n    color: $black !important;\n    font-weight: bold !important;\n    font-size: 14px !important;\n}\n   &-upload-btns {\n       padding: 10px 25px;\n       border: none;\n       color: white;\n       background-color: $primary;\n       border-radius: 10px;\n   }\n   &-remove-btn {\n       padding: 8px 20px;\n       border: none;\n       background-color: $mid-grey !important;\n       color: white !important;\n       border-radius: none !important;\n\n   }\n   &-submit {\n        @extend .zoning-upload-btns;\n        background-color: $mid-grey !important;\n}\n   &-select {\n       position: relative;\n       top: 4px;\n   }\n   &-dGap {\n       position:relative;\n       bottom: 7px;\n   }\n}\n","/* Containers CSS*/\n\n.info-page-image {\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n}\n\n.info-page-modal-image {\n    width: 100%;\n    height: 85vh;\n}\n\n.info-page-heading {\n    color:$secondary;\n    font-weight: bold;\n    font-size: 23px;\n}\n\n.info-page-content {\n    font-size: 15px !important;\n    color: black;\n}\n\n.info-page-vertical-center {\n    margin: 0;\n    position: absolute;\n    top: 50%;\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n}\n\n.info-page-grid-img {\n    width: 70px !important;\n    height: 70px !important;\n}\n\n.info-page-grid-head {\n    color: $light-text;\n}\n\n\n.info-page-grid-para {\n    font-size: 14px;\n    color: $light-text;\n}\n\n.info-page-bg-grey { background-color: $bg-grey2;}\n\n",".errors {\n    &-container {\n        min-height: calc(100vh - 129px);\n        margin-top: 100px;\n    }\n}",".economic-circle {\n    height: 45px;\n    width: 50px;\n    border-radius: 50%;\n    border: 7px solid $primary;\n    background-color: #FFFFFF;\n    position: relative;\n    left: 7px;\n    top: -4px;\n    z-index: 9;\n\n    .small {\n        //height: 25px;\n        //width:\n    }\n}\n.economic-circle2 {\n    @extend .economic-circle;\n    border: 1px solid $primary;\n}\n\n.economic-circle3 {\n    @extend .economic-circle2;\n    border: 1px solid $primary;\n    z-index: 999 !important;\n}\n  \n.economic-icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    color: $primary;\n    font-size: 20px;\n    margin-right: 2px;\n\n    .small {\n        font-size: 14px;\n    }\n}\n\n.economic-text {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    font-size: 13px;\n    font-weight: bold;\n    color: #FFFFFF;\n}\n.economic-text2 {\n   @extend .economic-text;\n   color: $primary;\n}\n\n.economic-text3 {\n    @extend .economic-text2;\n    color: $primary;\n    padding-top: 5px\n }\n\n.economic-light-text {\n    @extend .economic-text3;\n    font-size: 11px !important;\n    font-weight: normal;\n    padding-top: 0px\n}\n  \n.economic-step1 {\n    height: 35px;\n    width: 100%;\n    margin-top: 6px;\n    background-color: $primary;\n    position: absolute;\n    right: 0px;\n    width: 91%;\n    @media screen and (max-width: 600px) {\n        width: 93%;\n    }\n    @media screen and (max-width: 1120px) {\n        width: 94%;\n    }\n}\n  \n.economic-step2 {\n    @extend .economic-step1;\n    background-color: #FFFFFF;\n    border: 1px solid $primary;\n    border-left: none;\n    z-index: 99;\n    width: 91%;\n    @media screen and (max-width: 1150px) {\n        width: 93%;\n    }\n    @media screen and (max-width: 800px) {\n        width: 91%;\n    }\n    @media screen and (max-width: 600px) {\n        width: 93%;\n    }\n}\n\n.economic-step3 {\n    @extend .economic-step2;\n    height: 130px;\n    border: 1px solid $primary;\n    width: 94.5%;\n    @media screen and (max-width: 1150px) {\n        width: 96%;\n    }\n}\n\n\n/* Main Card */\n\n/* Card-1 */\n.card-container {\n    z-index: 1001;\n    padding-top: 10px;\n    position: relative;\n    width: 100%;\n    height: auto;\n    background-color: #FFFFFF;\n    border: none;\n    @media screen and (max-width: 600px) {\n    }\n}\n\n.adjusted-height-ev-card {\n    height: 600px;\n}\n\n.card-text-height {\n    min-height: 59px !important;\n    display: block;\n}\n\n.bar-container {\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n}\n\n.inside-container {\n    position: relative;\n    width: 100%;\n}\n.section-heading {\n    font-size: 14px;\n    color: $light-text;\n    font-weight: bold;\n    @media screen and (max-width: 1000px) {\n        font-size: x-small;\n    }\n}\n.section-text {\n    font-size: 10px !important;\n    color: $card-text;\n}\n\n.section-text-2 {\n    font-size: 12px;\n    color: $card-text !important;\n    position: relative;\n    bottom: 10px;\n}\n.section-text-3 {\n    font-size: 8px;\n    color: $card-text-2;\n    font-weight: normal !important;\n}\n.section-text-4 {\n    font-size: 10px;\n    font-weight: bold;\n    color: $light-text;\n}\n\n.section-text-5 {\n    font-weight: bold;\n    color: $light-text;\n}\n\n.card-section-text-colored {\n    @extend .inside-container;\n    color: $secondary;\n    font-size: 20px;\n    font-weight: bold;\n    white-space: pre;\n    display: block;\n    @media screen and (max-width: 1000px) {\n        font-size: small;\n    }\n\n}\n\n.card-section-text-colored-2 {\n    @extend .card-section-text-colored;\n    font-size: 12px;\n    color: $card-text !important;\n    top: 10px;\n}\n\n.card-bar {\n    @extend .inside-container;\n    align-self: center;\n}\n\n.bar-label {\n    @extend .section-text;\n    position: relative;\n    width: 20% !important;\n    text-align: right;\n    padding-right: 10px;\n}\n.section2-text {\n    @extend .section-text;\n    padding: 0% 10%;\n    font-weight: bold;\n    color: $light-text;\n    text-align: center;\n}\n.section1-label {\n    font-size: 12px;\n    color: $card-bar;\n}\n\n.card-section {\n    padding: 0px 20px;\n}\n\n\n/* Card-2 */\n\n.card2-section1-container {\n    position: relative;\n    padding-top: 14.2px;\n}\n\n.card2-section2-container {\n    position: relative;\n    padding-bottom: 1px;\n}\n\n.card2-section3-container {\n    position: relative;\n    padding-bottom: 0px;\n}\n\n\n\n.card2-section-bar-bottom-text {\n    @extend .section-text;\n    padding-top: 2px;\n    float: left;\n}\n.card2-section-bar-bottom-text-2 {\n    @extend .card2-section-bar-bottom-text;\n    float: right !important;\n}\n\n.card2-setting-container {\n    text-align: left;\n    margin-top: 35%;\n}\n\n.card2-section-text-colored {\n    @extend .card-section-text-colored;\n    color: $primary !important;\n}\n\n.card2-section-text-colored-2 {\n    @extend .card2-section-text-colored;\n    font-size: 12px;\n}\n\n.card2-setting-text {\n    @extend .section2-text;\n    padding: 0px;\n}\n\n\n\n\n.bottom-card-container {\n    @extend .card-container;\n    padding: 20px 10px;\n    width: 101%;\n}\n\n/* Slider Material UI Class */\n.MuiSlider-markLabel {\n    color: $slider-text !important;\n    font-size: 10px !important;\n}\n\n.PrivateValueLabel-circle-17 {\n    color: #FFFFFF !important;\n    background-color: $secondary !important;\n}\n.PrivateValueLabel-circle-65 {\n    @extend .PrivateValueLabel-circle-17;\n}\n.MuiSlider-markLabel {\n    top: 9px !important;\n    transform: translateX(5px) !important;\n}\n\n.MuiSlider-markLabelActive {\n    left: -20px !important;\n    transform: translateX(0)  !important;\n}\n\n.MuiSlider-marked {\n    margin-bottom: 0px !important;\n}\n\n/* Slider Material UI Class  END */\n\n\n.custom-track-label {\n    position:absolute;\n    left:0px;\n    top: -5px;\n    font-size:10px;\n    font-weight: bold;\n    color: $light-text;\n}\n\n\n\n\n.container-exit {\n    position: absolute;\n    z-index: 10002;\n    //top: 100px;\n    right: 5px;\n    cursor: pointer;\n\n}\n.container-top {\n    margin-top: 20px;\n}\n\n.container-hide {\n    display: none !important;\n}\n\n\n.euro-yearly {\n    @extend .section-text-2;\n    position: relative;\n    bottom: 3px;\n}\n\n.bottom-card-inputs {\n    width: 100%;\n    overflow: visible;\n    border: 1px solid $secondary;\n    text-indent: 10px;\n}",".energie-header-btn {\n  font-size: 13px;\n  font-weight: 600;\n  background-color: #790081;\n  padding: 8px;\n  color: white;\n  border-radius: 6px;\n  border: 1px;\n}\n\n.title {\n  font-weight: bold;\n  color: #702081;\n}\n\n.description-text {\n  font-size: smaller;\n  color: #929292;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
